// extracted by mini-css-extract-plugin
module.exports = {"boxWrapper":"RestaurantSkeleton_boxWrapper__2ZaoK"};